import { createReducer } from '@reduxjs/toolkit';
import { benchmarkActions } from '~/behaviors/actions/benchmark.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};
const reset = () => defaultState;

const mergeBenchmarkResults = (state, action) => {
  const benchmarkResults = action.payload.benchmarks;
  for (const surveyId in benchmarkResults) {
    if (!state[surveyId]) {
      state[surveyId] = benchmarkResults[surveyId];
      return state;
    }
    for (const benchmarkPeriod in benchmarkResults[surveyId]) {
      if (!state[surveyId][benchmarkPeriod]) {
        state[surveyId][benchmarkPeriod] = benchmarkResults[surveyId][benchmarkPeriod];
        return state;
      }
      for (const questionId in benchmarkResults[surveyId][benchmarkPeriod]) {
        if (!state[surveyId][benchmarkPeriod][questionId]) {
          state[surveyId][benchmarkPeriod][questionId] = benchmarkResults[surveyId][benchmarkPeriod][questionId];
          return state;
        }
        const existingBenchmarkIds = state[surveyId][benchmarkPeriod][questionId].map((benchmark) => benchmark.id);
        for (const benchmark of benchmarkResults[surveyId][benchmarkPeriod][questionId]) {
          if (existingBenchmarkIds.includes(benchmark.id)) continue;
          state[surveyId][benchmarkPeriod][questionId].push(benchmark);
        }
      }
    }
  }

  return state;
};

const results = createReducer({}, (builder) => {
  // Clean benchmarks if user try to log out or switch company
  builder
    .addCase(metaActions.reset, reset)
    .addCase(accountActions.logout.pending, reset)
    .addCase(accountActions.switchCompany.pending, reset)
    .addCase(benchmarkActions.fetchBenchmarks.fulfilled, mergeBenchmarkResults);
});

export { results };
